import { StakingPool } from '@trustpad/launchpad/dist/staking/types';
import * as React from 'react';

import { BNB, BUSD, LEDGITY, NFTPAD, TPAD, TPADV1 } from '~config/tokens';

const active: StakingPool[] = [
  {
    title: 'TPAD LP Farming',
    address: '0x3009F79A782B4F45c7243B1F75f0135D9B874160',
    decimals: 18,
    pairAddress: TPAD.pairAddress,
    stakeToken: [TPAD, BNB],
    rewardToken: TPAD,
    admins: [
      '0xAbAcc5D17f2Bcda0a3e505Eb96F29892E5A94E84', // me
      '0xa03f03170CD2F86239ea9fc57A0276573c2A708D',
    ],
    deprecated: false,
  },
];

const deprecated: StakingPool[] = [
  {
    title: 'TPAD Staking',
    address: '0xA37e3b6962de67362325ff5a44fF4414D617A215',
    decimals: 9,
    deprecated: true,
    stakeToken: TPADV1,
    rewardToken: TPADV1,
    admins: [
      '0xAbAcc5D17f2Bcda0a3e505Eb96F29892E5A94E84', // me
    ],
  },
  {
    title: 'IDO Staking',
    address: '0x2b1AD6eBaD818D5E0B29c694577E70f6E9344E91',
    decimals: 9,
    deprecated: true,
    hidden: false,
    stakeToken: TPADV1,
    rewardToken: TPADV1,
    admins: [
      '0xAbAcc5D17f2Bcda0a3e505Eb96F29892E5A94E84', // me
    ],
  },
  {
    title: 'Ledgity LP Staking',
    address: '0x0Ad9666034361Da3eAa2b5331AB6Fa06368806E0',
    decimals: 18,
    pairAddress: '0x95f69E1E32883a6772FB80810F8F7A76Ff61ab52',
    deprecated: true,
    stakeToken: [LEDGITY, BUSD],
    rewardToken: LEDGITY,
    admins: [
      '0x21C2f323B3420b9C309A653336683762f90f99d7', // Ledgity admin
      '0xa03f03170CD2F86239ea9fc57A0276573c2A708D', // me
    ],
  },
  {
    title: 'Ledgity LP Staking (OLD)',
    address: '0xb1119a02E0920Ce402Ec4a1BDa784B101E095428',
    decimals: 18,
    pairAddress: '0x95f69E1E32883a6772FB80810F8F7A76Ff61ab52',
    deprecated: true,
    stakeToken: [LEDGITY, BUSD],
    rewardToken: LEDGITY,
    description: () => null,
    admins: [
      '0x21C2f323B3420b9C309A653336683762f90f99d7', // Ledgity admin
      '0xa03f03170CD2F86239ea9fc57A0276573c2A708D', // me
    ],
  },
];

export const stakingPools: StakingPool[] = [...active, ...deprecated];
